import AhoyEvent from 'shared/ahoy_event';

export default class BannerAdTracker {
  static sendAdEvent(props) {
    var title = 'PLAYBACK::AD';
    props.ad_type = 'banner';
    AhoyEvent.send(title, props);
  }

  static sendAdEventStart(props) {
    props.ad_event = 'START';
    BannerAdTracker.sendAdEvent(props);
  }

  static sendAdEventEmpty(ad_slot, ad_uuid) {
    var props = {
      ad_slot: ad_slot,
      ad_uuid: ad_uuid,
      ad_event: 'EMPTY'
    };
    BannerAdTracker.sendAdEvent(props);
  }

  static sendAdEventImpressionViewable(ad_slot, ad_uuid) {
    var props = {
      ad_slot: ad_slot,
      ad_uuid: ad_uuid,
      ad_event: 'IMPRESSION_VIEWABLE'
    };
    BannerAdTracker.sendAdEvent(props);
  }

  static uuid(time = new Date().getTime(), randomFunction = Math.random){
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = (time + randomFunction()*16)%16 | 0;
        time = Math.floor(time/16);
        return (c=='x' ? r : (r&0x3|0x8)).toString(16);
    });
    return uuid;
  }
}
